import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  loading: boolean;
};

export class Submit extends React.Component<Props> {
  render() {
    return (
      <button
        className="modal__submit--email"
        id="modal_login_submit"
        type="submit"
        disabled={this.props.loading}
      >
        {this.props.loading ? (
          <FormattedMessage id="front/doctrine/login/components/submit/Submit.tsx/1" />
        ) : (
          <FormattedMessage id="front/doctrine/login/components/submit/Submit.tsx/2" />
        )}
      </button>
    );
  }
}
